(() => {
  const consentState = window.digitalConsentCartState;

  if (!consentState || typeof subscribe !== 'function') return;

  const getDigitalCartSignature = (items) =>
    items
      .filter((item) => item.requires_shipping === false && item.gift_card === false)
      .map((item) => item.key)
      .sort()
      .join('|');

  const getDigitalQuantityUpdates = (items) =>
    Object.fromEntries(
      items
        .filter(
          (item) =>
            item.requires_shipping === false && item.gift_card === false && item.quantity !== 1
        )
        .map((item) => [item.key, 1])
    );

  const uncheckConsentInputs = () => {
    document
      .querySelectorAll(`input[name="attributes[${consentState.attributeKey}]"]`)
      .forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.defaultChecked = false;
      });
  };

  let previousSignature = getDigitalCartSignature(consentState.items);
  let updateQueue = Promise.resolve();

  const getCurrentCart = async (cartData) => {
    if (cartData && Array.isArray(cartData.items) && cartData.attributes) return cartData;

    const cartResponse = await fetch(`${routes.cart_url}.js`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) throw new Error(`Cart request failed: ${cartResponse.status}`);

    return cartResponse.json();
  };

  const syncDigitalCart = async (cartData) => {
    let cart = await getCurrentCart(cartData);
    const quantityUpdates = getDigitalQuantityUpdates(cart.items);
    const normalizedQuantity = Object.keys(quantityUpdates).length > 0;

    if (normalizedQuantity) {
      const normalizeResponse = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({ updates: quantityUpdates }),
      });

      if (!normalizeResponse.ok) {
        throw new Error(`Digital quantity normalization failed: ${normalizeResponse.status}`);
      }

      cart = await normalizeResponse.json();
    }

    const currentSignature = getDigitalCartSignature(cart.items);

    if (
      currentSignature !== previousSignature &&
      cart.attributes[consentState.attributeKey] === consentState.acceptedValue
    ) {
      const clearResponse = await fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          attributes: {
            [consentState.attributeKey]: '',
          },
        }),
      });

      if (!clearResponse.ok) throw new Error(`Consent reset failed: ${clearResponse.status}`);

      uncheckConsentInputs();
    }

    previousSignature = currentSignature;

    if (normalizedQuantity) window.location.reload();
  };

  const enqueueSync = (event) => {
    const cartData = event?.cartData;

    updateQueue = updateQueue
      .then(() => syncDigitalCart(cartData))
      .catch((error) => {
        console.error('Unable to synchronize the digital cart.', error);
      });

    return updateQueue;
  };

  subscribe(PUB_SUB_EVENTS.cartUpdate, enqueueSync);

  if (Object.keys(getDigitalQuantityUpdates(consentState.items)).length > 0) enqueueSync();
})();
